// extracted by mini-css-extract-plugin
export default {"ErrorMsg":"ErrorMsg_ErrorMsg__ZWLft"};